import { Box } from '@lessonnine/design-system.lib';
import styled from 'styled-components';

export const BackButtonContainer = styled(Box)`
  left: 1.75rem;
  position: absolute;
  top: 1.813rem;
`;
